import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import SecaoClienteLoginForm from './SecaoClienteLoginForm';

export function SecaoClienteLoginPage() {
  return (
    <Flex
      minH="100vh"
      w="100%"
      bg="linear-gradient(135deg, #0A1628 0%, #1E3A5F 50%, #0D2137 100%)"
      align="center"
      justify="center"
      p={4}
    >
      <Box
        bg="white"
        borderRadius="2xl"
        boxShadow="2xl"
        w="100%"
        maxW="420px"
        p={8}
        textAlign="center"
      >
        <SecaoClienteLoginForm />
      </Box>
    </Flex>
  );
}
